'use strict'

import './component.scss';
import './ie.scss';

import isEnterOrSpacebarPressed from 'components/complement/isEnterOrSpacebarPressed';

const PRICE_SECTION_MAX_HEIGHT = 350;

function init() {
    expandPriceDetails();
    autoClick();

    let labelPrice = document.querySelectorAll('.label-price');
    if (labelPrice) {
        for (let label of labelPrice) {
            label.addEventListener('keydown', e => expandCollapseKeyboard(e));
            label.addEventListener('focusout', () => {
                const checkbox = document.getElementById(label.htmlFor);
                closePricePopover(checkbox);
            });
        }
    }
};

function closePricePopover(checkbox) {
    if (checkbox && checkbox.checked) {
        checkbox.checked = false;
        setHeightToPanel(checkbox);
    }
};

function autoClick() {
    let button = document.querySelector('.auto-click-button');

    setTimeout(function(){
        if (button) {
            button.click();
        }
    }, 500)
}

function expandPriceDetails() {
    let checkboxes = document.querySelectorAll('.info-price');

    if (checkboxes.length > 0) {
        for (let checkbox of checkboxes) {
            if (checkbox.checked) {
                setHeightToPanel(checkbox);
            }

            checkbox.addEventListener('change', () => setHeightToPanel(checkbox));
        }
    }
}

function setHeightToPanel(checkbox) {
    let buttonSection = checkbox.closest('.expandable-button'),
        expandedSection = buttonSection.querySelector('.expanded-price'),
        priceContainer = expandedSection.querySelector('.price-section'),
        label = document.querySelector(`label[for=${checkbox.id}]`);

    if (expandedSection) {
        if (checkbox.checked) {
            let priceSection = buttonSection.querySelectorAll('.price-container'),
                height = 0;

            if (priceSection.length > 1) {
                for (let section of priceSection) {
                    height += section.offsetHeight;
                }
            }

            else {
                height = priceSection[0].offsetHeight;
            }

            if (height > PRICE_SECTION_MAX_HEIGHT) {
                height = PRICE_SECTION_MAX_HEIGHT;
                priceContainer.style.overflow = "auto";
            }

            expandedSection.style.height = (height + 2).toString() + "px";
            priceContainer.style.height = (height + 2).toString() + "px";

            buttonSection.classList.add('opened');

            if (label) {
                label.setAttribute('aria-expanded', 'true');
            }
        }

        else {
            expandedSection.style.height = "0px";
            priceContainer.style.height = "0px";

            buttonSection.classList.remove('opened');

            if (label) {
                label.setAttribute('aria-expanded', 'false');
            }
        }
    }
}

/*
 * Accessibility
 */
function expandCollapseKeyboard(e) {
    e.stopPropagation();

    if (isEnterOrSpacebarPressed(e)) {
        e.preventDefault();
        e.target.click();
    }

    if (e.keyCode === 27) { // Esc
        const labelFor = e.target && e.target.htmlFor;
        if (labelFor) {
            const checkbox = document.getElementById(labelFor);
            closePricePopover(checkbox);
        }
    }
}

window.addEventListener('DOMContentLoaded', init);